module.exports = __webpack_public_path__ + "img/logo-lapiz.83ef34e9.svg";